/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkg_Log_Toast_DeletedInputs */

const vi_pkg_log_toast_deleted = /** @type {(inputs: Pkg_Log_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xoá mẻ khỏi sổ`)
};

/**

* @param {Pkg_Log_Toast_DeletedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkg_log_toast_deleted = /** @type {((inputs?: Pkg_Log_Toast_DeletedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkg_Log_Toast_DeletedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkg_log_toast_deleted(inputs)
});